import Skeleton from '@material-ui/lab/Skeleton'
import React from 'react'
import { useBestPracticeTipCardStyles } from '../styles/useBestPracticeTipCardStyles'

/**
 * Loading placeholder shaped to match BestPracticeTipCard. Reuses the
 * card's container styles so spacing matches once the real card replaces it.
 */
export const BestPracticeTipCardSkeleton = () => {
    const classes = useBestPracticeTipCardStyles()

    return (
        <div className={classes.card} data-testid="bestPracticeTipCardSkeleton">
            <Skeleton variant="circle" width={28} height={28} />
            <div className={classes.body}>
                <div className={classes.headerRow}>
                    <Skeleton variant="text" width="40%" height={16} />
                    <Skeleton variant="text" width="25%" height={14} />
                </div>
                <Skeleton variant="text" width="55%" height={14} />
                <Skeleton variant="text" width="90%" height={14} />
            </div>
        </div>
    )
}
